import React, { useContext } from "react";
import { GeographyType } from "models/Geography";
import EstateFormsComponent from "../EstateFormsComponent";
import AtticusDrawer from "../../shared/drawer/AtticusDrawer";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "AuthContextWrapper"
import FormsFilesHeader from "../FormsFilesHeader";

const EstateFormsView = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user, activeEstate } = useAuthContext()

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [drawerContents, setDrawerContents] = React.useState<JSX.Element>();
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const hasAccess = !user?.advisorGroup?.formsDisabled;

  return hasAccess ? (
    <div data-automation-id="page-content-estate-forms">
      {activeEstate && (
        <>
          <FormsFilesHeader
            title="Estate Forms"
            description="Here’s a running list of forms needing to be completed. As you or any other users connected to your estate add required forms, they will begin to appear here. Atticus may also add suggested forms, based on information provided or steps you take throughout the process."
            backButtonOptions={{
              text: "Back to My Forms",
              onClick: () => {
                navigate(`${location.pathname}/../`);
              },
            }}
          />
          <EstateFormsComponent
            sx={{ mb: 5 }}
            hideHeader
            openDrawer={handleDrawerOpen}
            setDrawerContents={setDrawerContents}
            onEmptyButtonClick={() => {
              navigate(`${location.pathname}/../forms-library`, {
                state: {
                  geography_type: GeographyType.State,
                  geography_id: activeEstate.stateId,
                },
              });
            }}
            goToProbateDetermination={() => {
              navigate(`${location.pathname}/../probate`);
            }}
          />
          <AtticusDrawer
            variant="temporary"
            anchor="right"
            open={drawerOpen}
            onClose={handleDrawerClose}
            contents={drawerContents}
          />
        </>
      )}
    </div>
  ) : (
    <></>
  );
};

export default EstateFormsView;
